export const Technician = 10;
export const Installer = 20;
export const Radius = 40;
export const RadiusAdmin = 50;
export const Cruise = 90;
export const Reseller = 100;



// WEBPACK FOOTER //
// ./src/config/roles.js